import { SET_VIEW_TRANSACTION} from "../action.js";

export const setViewTransaction = (transactions) => {
  return (dispatch) => {
    dispatch({ type: SET_VIEW_TRANSACTION, payload: transactions });
  };
};
